export default "__VITE_ASSET__62077695__"